export const LOGIN_PATH = "/login";

export const HOME_PATH = "/home";

export const APPLICANT_REGISTER_PATH = "/register/applicant";

export const LOGOUT_PATH = "/logout";

export const OFFER_PATH = "/offer";
export const OFFER_CREATE_PATH = "/offer/create";
export const OFFER_PUBLIC_LIST_PATH = "/offer/public-list";

export const PROFILE_PATH = "/profile";

export const DASHBOARD_PATH = "/dashboard";
export const DASHBOARD_OFFER_APPLICANT_PATH = "/dashboard/offer-applicant";

export const ASSESSMENT_PATH = "/assesment-form";

export const TECHNICAL_ASSESSMENT_PATH = "/technical-assessment";

export const OFFER_APPLICANT_CREATE_PATH = "/offer-applicant/apply";